import Project from "../main.js";

export class News {
	constructor() {
		this.project = new Project();

		this.DOM = {
			news: this.project.DOM.body.querySelector('.news'),
			newsArticles: this.project.DOM.body.querySelectorAll('.news__article'),
			newsHighlights: this.project.DOM.body.querySelectorAll('.news__highlight'),
		}

		if(!this.DOM.news || !this.DOM.newsArticles.length || !this.DOM.newsHighlights.length) {
			return null;
		}

		this.init();
	}

	init() {
		this.handleEvents()
	}

	handleEvents() {
		this.DOM.newsArticles.forEach((articleEl, index) => {
			articleEl.querySelector('.news__article__toggle')?.addEventListener('mouseenter', () => {
				this.changeArticles(index)
			})
		})
	}

	changeArticles(activeIndex) {
		this.DOM.newsArticles.forEach((articleEl, index) => {
			articleEl.classList.toggle('active', activeIndex === index)
		});

		this.DOM.newsHighlights.forEach((highlightEl, index) => {
			highlightEl.classList.toggle('active', activeIndex === index)
		});
	}
}